import * as FlatModels from '../../internal';
import { z } from 'zod';

export const themeColorList: FlatModels.ColorDesignModels.ThemeColorList = [
  { "name": "Gelb", "value": 'yellow', "hexValue": "#f5a623" },
  { "name": "Violett", "value": 'violet', "hexValue": "#9E32B3" },
  { "name": "Magenta", "value": 'magenta', "hexValue": "#E12599" },
  { "name": "Cyan", "value": 'cyan', "hexValue": "#4A90E2" },
  { "name": "Mintgrün", "value": 'mint', "hexValue": "#50e3c2" },
  { "name": "Grün", "value": 'green', "hexValue": "#BFE125" },
] as const;

export const ThemeColorHexValueSchema = z.record(z.string(), z.string());

export const ThemeColorHexValue: z.infer<typeof ThemeColorHexValueSchema> = {
  [themeColorList[0].name]: themeColorList[0].hexValue,
  [themeColorList[1].name]: themeColorList[1].hexValue,
  [themeColorList[2].name]: themeColorList[2].hexValue,
  [themeColorList[3].name]: themeColorList[3].hexValue,
  [themeColorList[4].name]: themeColorList[4].hexValue,
  [themeColorList[5].name]: themeColorList[0].hexValue,
}

export const colorPickerList: FlatModels.ColorDesignModels.ColorPickerList = [
  { "name": "Standardwert" },
  { "name": "Schwarz", "value": "#000000" },
  { "name": "Weiss", "value": "#ffffff" },
  { "name": "Hellgrau", "value": "#9B9B9B" },
  { "name": "Dunkelgrau", "value": "#4b4b4b" },
  { "name": "Weinrot", "value": "#A00057" },
  { "name": "Rot", "value": "#FA0202" },
  { "name": "Orange", "value": "#D56038" },
  { "name": "Gelb", "value": "#F39200" },
  { "name": "Hellgrün", "value": "#A6CA5E" },
  { "name": "Grün", "value": "#357E32" },
  { "name": "Türkis", "value": "#169995" },
  { "name": "Blau", "value": "#1F89CD" },
  { "name": "Dunkelblau", "value": "#210B8A" },
  { "name": "Violett", "value": "#6E6EBE" }
] as const;